import React from 'react';

const Copyright = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Copyright Notice</h1>
        
        <div className="space-y-6 text-gray-700">
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">Copyright © {currentYear} Azúcar Multimedia</h2>
            <p className="mb-4">
              All rights reserved. All content, materials, information, software, products, and services 
              available on or through this website and mobile application, including but not limited to 
              text, graphics, logos, button icons, images, audio clips, digital downloads, data compilations, 
              and software, are the property of Azúcar Multimedia or its content suppliers and are protected 
              by United States and international copyright laws.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">Trademarks</h2>
            <p className="mb-4">
              "AzucarAI", "Azúcar Multimedia", and all related names, logos, product and service names, 
              designs, and slogans are trademarks of Azúcar Multimedia or its affiliates or licensors. 
              You may not use such marks without the prior written permission of Azúcar Multimedia. 
              All other names, logos, product and service names, designs, and slogans on this website 
              and application are the trademarks of their respective owners.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">Ownership of Content</h2>
            <p className="mb-4">
              The compilation of all content on this website and mobile application is the exclusive 
              property of Azúcar Multimedia and is protected by U.S. and international copyright laws. 
              All software used on this website and in our applications is the property of Azúcar Multimedia 
              or its software suppliers and is protected by United States and international copyright laws.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">Permitted Uses</h2>
            <p className="mb-4">
              You may access, view, and use the content and services provided on this website and mobile 
              application for your personal, non-commercial use only, subject to the restrictions set forth 
              in these terms and the conditions of use. You may download or print a single copy of the 
              content for your personal use, provided that you:
            </p>
            <ul className="list-disc ml-6 space-y-2 mb-4">
              <li>Keep all copyright and other proprietary notices intact</li>
              <li>Do not modify or alter the content in any way</li>
              <li>Do not use the content for any commercial purpose or public display</li>
              <li>Do not transfer the content to another person or "mirror" the content on any other server</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">Prohibited Uses</h2>
            <p className="mb-4">
              Except as expressly permitted above, you may not reproduce, distribute, modify, create 
              derivative works of, publicly display, publicly perform, republish, download, store, or 
              transmit any of the material on our website or mobile application without prior written 
              consent from Azúcar Multimedia.
            </p>
            <p className="mb-4">
              This includes, but is not limited to:
            </p>
            <ul className="list-disc ml-6 space-y-2 mb-4">
              <li>Using the content for any commercial purpose or for any public display</li>
              <li>Removing or modifying any copyright, trademark, or other proprietary notices</li>
              <li>Transferring the content to another person or website</li>
              <li>Using any automated system or software to extract data from the website or application</li>
              <li>Attempting to decompile or reverse engineer any software contained on the website or application</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">User-Generated Content</h2>
            <p className="mb-4">
              When you upload, submit, or otherwise provide content to our services (including but not 
              limited to photos, text, data, and other materials), you retain ownership of your content. 
              However, by submitting content to our platform, you grant Azúcar Multimedia a worldwide, 
              non-exclusive, royalty-free license to use, reproduce, modify, adapt, publish, and display 
              such content solely for the purpose of providing and improving our services to you.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">Digital Millennium Copyright Act (DMCA)</h2>
            <p className="mb-4">
              If you believe that any content on our website or application infringes your copyright, 
              please notify us immediately. We respect the intellectual property rights of others and 
              will respond to notices of alleged copyright infringement that comply with applicable law.
            </p>
            <p className="mb-4">
              To file a DMCA notice, please provide the following information to our designated copyright agent:
            </p>
            <ul className="list-disc ml-6 space-y-2 mb-4">
              <li>A physical or electronic signature of the copyright owner or authorized representative</li>
              <li>Identification of the copyrighted work claimed to have been infringed</li>
              <li>Identification of the material that is claimed to be infringing and its location</li>
              <li>Your contact information (address, telephone number, and email address)</li>
              <li>A statement that you have a good faith belief that the use is not authorized</li>
              <li>A statement under penalty of perjury that the information is accurate</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">Copyright Infringement Claims</h2>
            <p className="mb-4">
              Please send all copyright infringement notices to:
            </p>
            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="font-semibold">Copyright Agent</p>
              <p>Azúcar Multimedia</p>
              <p>Email: <a href="mailto:info@azucarmultimedia.com" className="text-blue-600 hover:text-blue-800 underline">info@azucarmultimedia.com</a></p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">Third-Party Content</h2>
            <p className="mb-4">
              Some content on our website and application may be provided by third parties. Such content 
              is the property of the respective third parties and is protected by copyright and other 
              intellectual property laws. We make no representations or warranties regarding the accuracy, 
              completeness, or reliability of any third-party content.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">Updates and Changes</h2>
            <p className="mb-4">
              Azúcar Multimedia reserves the right to update, modify, or discontinue any portion of the 
              website or mobile application at any time without notice. We may also update this Copyright 
              Notice from time to time to reflect changes in our practices or applicable law.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">Contact Information</h2>
            <p className="mb-4">
              If you have any questions about this Copyright Notice or wish to request permission to use 
              any of our content, please contact us at:
            </p>
            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="font-semibold">Azúcar Multimedia</p>
              <p>Email: <a href="mailto:info@azucarmultimedia.com" className="text-blue-600 hover:text-blue-800 underline">info@azucarmultimedia.com</a></p>
            </div>
          </section>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-sm text-gray-500 text-center">
            © {currentYear} Azúcar Multimedia. All rights reserved.
          </p>
          <p className="text-sm text-gray-500 text-center mt-2">
            Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Copyright;

